/**
 * Transform collection array related to the ordering method
 * @param  {Array} collection parameter of the collection datas
 * @param  {String} mode parameter of the ordering mode
 * @return {Array} ordered collection data
 */
export const orderMonopolyCollections = (collection, mode)  => {
    // mode: entry date
    if (mode == 'entry-date') return collection;

    // mode: property set
    const item_order = ["brown","light blue","pink","orange","red","yellow","green","dark blue","railroad","community chest"];
    // Note: Brown, Light Blue, Pink, Orange, Red, Yellow, Green, Dark Blue, Black (Railroads), Community Chest
    if (mode == 'property-set') return collection.sort((a, b) => item_order.indexOf(a.color) - item_order.indexOf(b.color));

    // mode: default
    return collection;
};
